import { CategoryPageInfo } from 'CategoryPage';

import { ShopMoreType } from '@/types/product';
import fetch, { NewAxiosRequestConfig } from '@/utils/axios';

/**
 *
 * @param params 获取热门搜索关键词
 * @param config
 */
export const getPopularSearch = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/search/hot_keywords', params, config);
};

export const getSearchProduct = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/search/suggestion', params, config);
};

export const getSearchHotKeywords = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/search/suggestion/search_bar/tips', params, config);
};

/**
 * @param params 获取商品详情
 * @param config
 */

export const getStaticDetail = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/item/v5/product/detail/static', params, config);
};

export const getDetail = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/item/v5/product/detail', params, config);
};

export const getDetailV2 = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/item/v5/product/detail/v2', params, config);
};

/**
 * @param params 动态获取分类
 * @param config
 */

interface GetCategoriesParams {
  type?: string;
  sales_org_id?: number;
  [key: string]: any;
}
export const getCategories = (params?: GetCategoriesParams, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/item/v5/categories', params, config);
};
export interface GetCategoriesResultParams {
  zipcode: string | number;
  date: string;
  lang: string;
  filter_sub_category: string;
  filters?: any;
  offset?: number;
  page?: number;
  limit?: number;
  sign?: string;
  sort?: string;
  from_page?: string;
  out_filters?: any;
}

//  categories page
export const getCategoriesResult = (
  params?: GetCategoriesResultParams,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/item/v3/search/catalogue', params, config);
};

// categories page v2
export const getCategoriesResultV2 = (params?: GetCategoriesResultParams, config?: NewAxiosRequestConfig) => {
  return fetch.get<any, AResponse<CategoryPageInfo>>('/ec/item/v3/search/content/catalogue', params, config);
};

export const getCategoriesResultV4 = (params?: GetCategoriesResultParams, config?: NewAxiosRequestConfig) => {
  return fetch.get<any, AResponse<CategoryPageInfo>>('/ec/item2/content/v1/catalogue', params, config);
};

export const getCategoriesResultV5 = (params?: GetCategoriesResultParams, config?: NewAxiosRequestConfig) => {
  return fetch.get<any, AResponse<CategoryPageInfo>>('/ec/item/v5/content/feed/catalogue', params, config);
};

//   search page
export const getSearchResult = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/search/keyword', params, config);
};

//   search page
export const getSearchResultForShare = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/social/product/v3/search', params, config);
};

/**
 * @param params 获取静态分类
 * @param config
 */

export const getStaticCategory = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/item/v5/categories/static', params, config);
};

/**
 * @param params 获取所有销售组织
 * @param config
 */

export const getSalesOrg = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/item/common/sales_org_ids', params, config);
};

/**
 * 产品相关模块商品查询
 * @param {number} productId 商品ID
 * @param {number} limit 查询数量
 */
export const getRelatedModulesProduct = (
  productId?: number,
  limit = 10,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(
    `/ec/item/v5/product/single/modules`,
    {
      product_id: productId,
      limit
    },
    config
  );
};

/**
 * @param params 无搜索结果反馈
 * @param config
 */
export const sendNoResultFeedback = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post('/ec/item/noresult', params, config);
};

export const getActiveReferralEvent = () => {
  return fetch.get('/ec/item/invite_friends/get_active_referral_event');
};

export const getStoreInfo = (
  params?: {
    zipcode: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  let url = `/ec/item/store/is_select?zipcode=${params?.zipcode}`;
  if (config?.ctx?.query?.['grocery-store']) {
    url = `${url}&store=${config?.ctx?.query?.['grocery-store']}`;
  }
  return fetch.get(url, {}, config);
};

export const getStoreList = (
  params?: {
    zipcode: string;
    lang: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/item/store/list`, params, config);
};

export const setRemind = (
  params: {
    zipcode: string;
    is_selected: boolean;
    is_remind: boolean;
    store_id: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.post(`/ec/item/store/remind`, params, config);
};

export const selectStore = (
  params: {
    zipcode: string;
    is_selected: boolean;
    is_remind: boolean;
    store_id: string;
    store_select_method?: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.post(`/ec/item/store/select`, params, config);
};
/**
 * 猜你喜欢
 */
export const getYouMayLike = (
  product_id: number,
  params?: { limit?: number; offset?: number; page?: string },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/item/v2/items/${product_id}/similar`, params, config);
};

/**
 * Account-曾经购买
 * @param params
 * @param config
 * @returns
 */
export const getBoughtList = (
  params: {
    zipcode?: string | number;
    offset?: number;
    limit?: number;
    filter_sub_category: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/item/v5/recommend/bought/catalogue`, params, config);
};

/**
 *
 * @param params 购物车的猜你喜欢
 * @param config
 * @returns
 */
export const getYouMayLinkInCart = (
  params?: { limit?: number; offset?: number },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/item/v5/preference/cart', params, config);
};

/**
 *
 * @param params 获取曾经购买购物车
 * @param config
 */
export const getBoughtInfoInCart = (
  params?: { limit?: number; offset?: number },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/item/v5/recommend/bought/product/list', params, config);
};

/**
 * Account-我的收藏列表
 * @param params
 * @param config
 * @returns
 */
export const getFavoriteList = (
  params: {
    zipcode?: string | number;
    offset?: number;
    limit?: number;
    filter_sub_category?: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/item/v5/me/favorites/list`, params, config);
};

/**
 * @param params 批量取消收藏
 * @param config
 */
export const deleteFavoriteList = (
  params?: {
    product_ids: number[] | string[];
    is_watch: boolean;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.post('/ec/item/v5/me/favorites/watch/batch', params, config);
};

/**
 *
 * @param params 获取theme landing页面一级分类
 * @param config
 * @returns
 */
export const getThemesList = (
  params?: {
    from_page?: string;
  } & ObjectType,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/item/v3/themes/simple', params, config);
};

/**
 * @deprecated Please use getThemeLandingTree/getThemeLandingItems in theme_landing.
 * Keep for backward compatibility.
 * @param params 获取theme landing页面数据
 * @param config
 * @returns
 */
export const getThemeData = (params?: { tag_id: number }, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  // return fetch.get('/ec/item/v3/themes/items', params, config);
  return fetch.get('/ec/bff/promotion/themeTree', params, config);
};

/**
 * @param params
 * @param config
 * @returns
 */
export const getVendorData = (params?: any, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/item/v5/product/query/vender`, params, config);
};

export const getVendorProduct = (
  vender_id?: number,
  filter_product_id?: number,
  limit?: number,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/item/v1/recommend/vender`, { vender_id, filter_product_id, limit }, config);
};

/**
 * 查询promotion offer活动列表
 * @param params
 * @param config
 * @returns
 */
export const getOfferInfo = (params?: any, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/item/promotion/search`, params, config);
};

/**
 * 获取rtg数量
 * @param params
 * @param config
 * @returns
 */
export const getRtgCount = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/item/v3/search/rtg/count`, params, config);
};

/**
 * 获取rtg商品列表
 * @param params
 * @param config
 * @returns
 */
export const fetchRtgData = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/item/v3/search/rtg`, params, config);
};

/**
 * 获取brand商品信息
 * @param params
 * @param config
 * @returns
 */
export const getBrandProducts = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/item/v5/product/query/brand`, params, config);
};

/** 获取品牌的协议文案  */
export const getVendorPolicy = (
  vendorId: string,
  params?: ObjectType,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/marketplace/vendor/seller/introduction/v2/${vendorId}`, params, config);
};

/** 获取vendor search   */
export const getVendorSearchData = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/item/v5/product/query/seller/keyword', params, config);
};

/**
 * 获取rewards landing页面产品数据
 * @param params
 * @param config
 * @returns
 */
export const fetchRewardsProducts = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/item/v2/items/rewards_day`, params, config);
};

/**
 * 获取rewards landing页面产品数据
 * with category api
 * @param params
 * @param config
 * @returns
 */
export const fetchRewardsProductsV2 = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/item/v5/rewards_day/modules`, params, config);
};

/**
 * 排行榜分类列表
 */
export const getRankingCatalogList = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/item/v5/top_ranking/catalogue/list', {}, config);
};

/**
 * 榜单列表搜索
 */
export const getRankingList = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/item/v5/top_ranking/list', params, config);
};

/**
 * 榜单详情
 */
export const getRankingDetail = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/item/v5/top_ranking/detail', params, config);
};

/**
 * 查询榜单关联榜单列表
 */
export const getRankRelatedList = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/item/v5/top_ranking/related/list', params, config);
};

/**
 * 榜单列表分享
 */
export const getRankingListShareInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/growth/share/ranking-list', params, config);
};

/**
 * 榜单列表分享
 */
export const getRankingDetailShareInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/growth/share/ranking-detail', params, config);
};

/**
 * 获取mkpl商家推荐商品
 * @param params
 * @param config
 * @returns
 */
export const getSellerRecommendProduct = (id: number, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/item/v1/recommend/modules/cart/seller/${id}`, {}, config);
};

//  seo model page
export const getSearchModelResult = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/item/v5/model_page/${params?.page_num}/search`, params, config);
};

/**
 * 获取品牌落地页面的品牌列表数据
 * @param params
 * @param config
 * @returns
 */
export const getBrandLandingResult = (
  params?: {
    offset: number;
    limit: number;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/item/v1/recommend/brand/list', params, config);
};

//
/**
 * 获取topic的想
 * @param id
 * @param config
 * @returns
 */
export const getTopicInfo = (id?: string, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/item/v4/themes/${id}/info`, {}, config);
};

/**
 * 获取topic的产品信息
 * @param params
 * @param config
 * @returns
 */
export const getTopicProducts = (
  params?: {
    top_tag_id: string;
    l2_tag_id?: string;
    l3_tag_id?: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/item/v4/themes/products`, params, config);
};

/**
 * @description 返回topic页面category树结构，包括一级分类和二级分类
 * @param params
 * @param config
 * @returns
 */
export const getTopicThemeTree = (
  params?: {
    top_theme_id: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/item/v3/themes/theme/tree`, params, config);
};

/**
 * @description 返回topic页面商品列表
 * @param params theme_id: 用户选中的category, 不论一级二级
 * @param config
 * @returns
 */
export const getTopicProductsV2 = (
  params?: {
    theme_id: number;
    top_theme_id: number;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/item/v3/themes/theme/items`, params, config);
};

/**
 * Theme landing tree API (alias for clarity).
 */
export const getThemeLandingTree = (
  params?: {
    top_theme_id: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return getTopicThemeTree(params, config);
};

/**
 * Theme landing items API (alias for clarity).
 */
export const getThemeLandingItems = (
  params?: {
    theme_id: number;
    top_theme_id: number;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return getTopicProductsV2(params, config);
};

/**
 * 获取topic module info
 * @param params
 * @param config
 * @returns
 */
export const getTopicModuleInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/item/v4/themes/collection/carousel`, params, config);
};

/**
 * topic theme share info
 * @param params
 * @param config
 * @returns
 */
export const getTopicShareInfo = (
  params?: {
    topic_id: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/growth/share/topic`, params, config);
};

/**
 * 获取品牌详情卡片列表
 * @param params
 * @param config
 * @returns
 */
export const getBrandCardList = (
  params?: {
    exclude_brand_key: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/item/v1/recommend/card/brand/list', params, config);
};

/**
 * 获取品牌详情相关商品
 * @param params
 * @param config
 * @returns
 */
export const getBrandProductList = (
  params?: {
    exclude_brand_key: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/item/v1/recommend/brand/product/list', params, config);
};

/**
 * 获取品牌
 * @param params
 * @param config
 * @returns
 */
export const getBrandProductHistory = (
  params?: {
    offset?: number;
    limit?: number;
    product_id?: number;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/item/v5/product/single/modules/second`, params, config);
};

export const getminimarket = (params?: {}, config?: NewAxiosRequestConfig) => {
  return fetch.get(`/ec/item/v1/ds_collection/mini_market/detail`, params, config);
};

/**
 *  秒杀活动信息 ongoing_exist / begoing_exist
 * @param params
 * @param config
 * @returns
 */
export const lightningDealsInfo = (params, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/item/lightning_deals/info', params || {}, config);
};

/**
 * 获取hero商品
 * @param params
 * @param config
 * @returns
 */
export const getHeroProductsByPage = (params?: Record<string, any>, config?: NewAxiosRequestConfig) => {
  return fetch.get(`/ec/item/v3/search/hero/product`, params, config);
};

/**
 * 获取秒杀活动商品列表
 * @param params
 * @param config
 * @returns
 */
export const getLightningDealsList = (
  params: { status; zipcode; date; limit?: number; filter?: any; offset?: number },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/item/lightning_deals/product_list', params, config);
};

export const getUserStickerDataByProductId = (
  params?: {
    product_id: string;
    from_page?: 'pdp' | '';
  },
  config?: NewAxiosRequestConfig
) => {
  return fetch.get(`/ec/item/items/statistics`, params, config);
};

export type GetActivityRecommendTabParams = {
  key?: string;
  name?: string;
  shop_more_type?: ShopMoreType;
  diff_amount?: number | string;
  ref_value?: string | null;
  refer_value?: string;
  type: string;
};

/**
 * 凑单页面顶部tab列表
 * @param params
 * @param config
 * @returns
 */
export const activityRecommendTab = (
  params?: GetActivityRecommendTabParams,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/item/v5/shop_more/tab', params, config);
};

export type GetActivityRecommendListParams = {
  tab: string;
  price_group_key: string;
  shop_more_type: ShopMoreType;
  ref_value?: string | null;
  diff_amount: number | string;
  offset: number;
  limit: number;
  type: string;
  refer_value?: string | null;
};

/**
 * 凑单页面商品列表
 * @param params
 * @param config
 * @returns
 */
export const activityRecommendList = (
  params: GetActivityRecommendListParams,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/item/v5/shop_more/products', params, config);
};

/**
 * 换购页面商品列表
 * @param params
 * @param config
 * @returns
 */
export const activityShopDealList = (
  params: { type: string; filter_alcohol: number },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/item/activity/trade_in`, params, config);
};

/**
 * 换购页面商品列表(接口迁移至item)
 * @param params
 * @param config
 * @returns
 */
export const getDiscountListV2 = (
  params: {
    type: 'normal' | 'pantry';
    deal_id: number | string;
    delivery_sale_org_id: number | string;
    filter_alcohol: 0 | 1; // 是否过滤酒类 1 要过滤, 0 不过滤
    offset?: number;
    limit?: number;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  /**
   * 修改地址：https://sayweee.atlassian.net/browse/PEP-12272
   */
  return fetch.get('/ec/item/v5/trade_in/list', params, config);
};

/**
 * 查询曾经购买商品接口
 * @link https://docs.google.com/document/d/1wm8Ne_UCbhqF1f9mhzcIxy9MS79a_0B6VkRWoSmFX2M/edit
 */
export const getEverBoughtList = (params, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/item/v5/recommend/bought', params, config);
};

/**
 * sku level coupon 通过coupon plan_id 查相关商品
 * @param params
 * @param config
 * @returns
 */
export const getSkuCouponProducts = (
  tag_type: string,
  tag_id: string | number,
  params?: ObjectType,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/item/v5/product/query/tag/${tag_type}_${tag_id}`, params, config);
};

/**
 * 获取free gift产品接口
 * @param params
 * @param config
 * @returns
 */
export const getFreeGiftProducts = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/promotion/promotions/landing/products`, params, config);
};

/**
 * 获取预售商品弹窗信息接口
 * @param params
 * @param config
 * @returns
 */
export const getPreSaleInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/item/sale_events/presale/queryById`, params, config);
};

/**
 * 获取pdp页面最近浏览产品列表
 * @param params
 * @param config
 * @returns
 */
export const getViewHistory = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/item/v2/items/waterfall`, params, config);
};

export const setStoreLanguage = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/item/store/select/lang_change`, params, config);
};

export interface GetSearchPropsParams {
  props_key: string | number;
  from_page: string;
  offset?: number;
  limit?: number;
  filter_sold_out?: boolean;
}
// 获取5pm商品列表
export const getSearchProps = (params?: GetSearchPropsParams, config?: NewAxiosRequestConfig) => {
  return fetch.get<any, AResponse>('/ec/item/v3/search/props', params, config);
};

export interface GetSearchSupportParams {
  zipcode?: string | number;
  from_page: string;
}
export const getSearchSupport = (params?: GetSearchSupportParams, config?: NewAxiosRequestConfig) => {
  return fetch.get<any, AResponse>('/ec/item/v3/search/support/guaranteed', params, config);
};
interface Get5PMSupportByZipcodeParams {
  zipcode: number;
  // develiverByFive--5pm落地页 cart--购物车 category-分类页
  from_page: 'cart' | '5pm' | 'category';
}
export const get5PMSupportByZipcode = (params: Get5PMSupportByZipcodeParams) => {
  return fetch.get<any, AResponse<{ supportGuaranteed: boolean; externalEndTime: string; externalEndTimeStr: string }>>(
    '/ec/item/v3/search/support/guaranteed',
    params
  );
};

export interface CategoriesPropItem {
  num: string;
  label: string;
  key: string;
}
interface CategoriesProps {
  category_list: CategoriesPropItem[];
}
export const getCategoriesList = (
  params?: {
    type: string;
  },
  config?: any
): Promise<AResponse<CategoriesProps>> => {
  return fetch.get(`/ec/item/v5/categories`, params, config);
};

export const getPantryProducts = (
  { storeKey, lang }: { storeKey: string; lang: string },
  config?: NewAxiosRequestConfig
) => {
  return fetch.get(`/ec/bff/mobile/pantry/products`, { storeKey, lang }, config);
};

/**
 * 获取订阅信息接口
 * @param params
 * @param config
 * @returns
 */
export const getSubscribeInfo = (params: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/item/v5/product/subscribe/detail`, params, config);
};

export interface GetProductSimilarItemsParams {
  product_id: number; // 原始商品 ID
  offset?: number; // 分页偏移量
  limit?: number; // 每页返回的商品数量
}
export const getProductSimilarItems = (
  params: GetProductSimilarItemsParams,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/item/v5/product/single/replace', params, config);
};
